import React from 'react'
import { CSSTransition } from 'react-transition-group'
import styled from 'styled-components'
import { useSelector } from '../store/hooks'
import { ANIMATION_SCALE } from '../style'

const PreloaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 55px;
  user-select: none;

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  img {
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 0;
    opacity: 0.8;
  }

  &.cs-pl-exit {
    opacity: 1;
  }
  &.cs-pl-exit-active {
    opacity: 0;
    transition: opacity ${400 * ANIMATION_SCALE}ms;
  }
  &.cs-pl-exit-done {
    display: none;
  }
`

const PreloaderContent = styled.div`
  transform: translateZ(0);
`

const Preloader: React.FC<{ children?: () => JSX.Element }> = ({ children }) => {
  const loaded = useSelector((state) => !state.data.loading)
  return (
    <>
      <PreloaderContent>{!!loaded && children?.()}</PreloaderContent>
      <CSSTransition in={!loaded} timeout={400 * ANIMATION_SCALE} classNames="cs-pl">
        <PreloaderOverlay>
          <div className="container">
            <img src={require('../assets/preloader.gif')} width="30" height="30" />
          </div>
        </PreloaderOverlay>
      </CSSTransition>
    </>
  )
}

export default Preloader
